import {coachingApi} from 'sources/api';
import CoachingReviewType from 'records/CoachingReviewType';
import CoachingMeetingCategory from 'records/CoachingMeetingCategory';

export default class CoachingReviewTypeSource {
  static fetchAll() {
    return coachingApi
      .getJson(`reviews/types`)
      .then(res => res.map(r => new CoachingReviewType(r)));
  }

  static fetchById(id) {
    return coachingApi.getJson(`reviews/types/${id}`).then(res => new CoachingReviewType(res));
  }

  /**
   * Fetch multiple by id.
   *
   * We use this to fetch inactive review types by ID when active reviews are using an inactive review
   * type. This lets us show the review details and lets participants edit the review.
   *
   * This isn't wired to an action or to the store, because we don't want to store inactive review
   * types (in particular, they shouldn't be available for use in new reviews).
   */
  static fetchByIds(ids) {
    return coachingApi
      .getJson(`/reviews/types/fetch`, {params: {typeId: ids}})
      .then(res => res.map(r => new CoachingReviewType(r)));
  }

  static upsert(coachingReviewType) {
    return coachingApi
      .postJson(`reviews/types`, coachingReviewType)
      .then(res => new CoachingReviewType(res));
  }

  static delete(id) {
    return coachingApi.deleteJson(`reviews/types/${id}`).then(() => id);
  }

  static fetchMeetingCategories() {
    return coachingApi
      .getJson('reviews/types/meeting-categories')
      .then(res => res.map(r => new CoachingMeetingCategory(r)));
  }

  static toggleHidden(catId) {
    return coachingApi.putJson(`reviews/types/meeting-categories/${catId}/toggle_hidden`);
  }
}
